import { Component, OnInit,Input, ViewChild } from '@angular/core';
import { Agent,AgentServicev2 } from '../agent-builder-services/agent.service';
import { NzTableComponent, NzTableFilterValue, NzTableQueryParams, NzTableSortOrder } from 'ng-zorro-antd/table';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AgentBuilderMessagesLogDetailComponent } from '../agent-builder-messages-log-detail/agent-builder-messages-log-detail.component';


export interface LogMessage {
  sessionId: string;
  totalRounds: number;
  totalMessages: number;
  totalPromptToken: number | null;
  totalCompletionTokens: number | null;
  totalTokens: number | null;
  dataHoraInicial: string;
  dataHoraFinal: any;
}

@Component({
  selector: 'agent-builder-messages-log',
  templateUrl: './agent-builder-messages-log.component.html',
  styleUrls: ['./agent-builder-messages-log.component.scss'],
  standalone: false
})
export class AgentBuilderMessagesLogComponent implements OnInit {
  messages: LogMessage[] = [];
  loading = false;

  @ViewChild('nzTable',{ static: false }) table:NzTableComponent<any>;
  
  visible: Record<string, boolean> = {
    sessionId: false,
    totalRounds: false,
    totalMessages: false,
    totalPromptToken: false,
    totalCompletionTokens: false,
    totalTokens: false,
    dataHoraInicial: false,
    dataHoraFinal: false
  };

  searchData: Record<string, string> = {
    sessionId: null,
    totalRounds: null,
    totalMessages: null,
    totalPromptToken: null,
    totalCompletionTokens: null,
    totalTokens: null,
    dataHoraInicial: null,
    dataHoraFinal: null
  };

  activeColumnKey = 'sessionId';
  detailmessageLoading:boolean = false;
  activeDateValue: Date | null = null;
  expandSet = new Set<string>();  
  currentFilter: { key: string; value: NzTableFilterValue }[] = [];
  detailMessageData:any[] = [];

  onExpandChange(id: string, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  
  pageIndex = 1;
  pageSize = 20;
  total = 0;

  sortField: string | null = null;
  sortOrder: string | null = null;

  constructor(private agentService: AgentServicev2, private nzModal: NzModalService, private ls:LanguageServices) {}

  @Input() agent: Agent;


  ngOnInit() {
    this.loadData();
  }

  loadData() {
    if ( this.agent.qaTable==null || this.agent.qaTable.trim() == '' ) {
      return;
    }
    this.loading = true;

    this.agentService
      .getLogMessage(this.agent, this.currentFilter, this.pageIndex-1, this.pageSize, this.sortField, this.sortOrder)
      .subscribe((res:any) => {
        this.messages = res.SQL || [];
        this.total = res.totalLines;
        this.loading = false;
      });
  }

  parseData(data: string): any {
    if ( data == null || data.trim() === '') {
      return '{}';
    }
    try {
      return JSON.stringify(JSON.parse(data),null, 2);
    } catch {
      return JSON.stringify(data, null, 2);
    } 
  }

  sortString = (a: any, b: any) => {
    return (a.sessionId || '').localeCompare(b.sessionId || '');
  };

  onFilterVisibleChange(field: string, isVisible: boolean, isDate: boolean=false): void {
    this.visible[field] = isVisible;
    if (isVisible) {
      this.activeColumnKey = field;
      if ( isDate ){
        this.activeDateValue = this.searchData[field] ? new Date(this.searchData[field]) : null;
      }
      
    }
  }

  onDateSelected(date: Date | null, field: string): void {
    this.activeDateValue = date;
    if (!date) {
      this.searchData[field] = '';
      return;
    }
    // Converte Date para string no formato yyyy-MM-dd HH:mm:ss
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    this.searchData[field] = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }


  search(field: string) {
        let index = this.currentFilter.findIndex(d=>d.key==field);
        
        if  ( index == -1 ){
            this.currentFilter.push({
            key:field,
            value:this.searchData[field]
            })
        }else{
            this.currentFilter.find(d=>d.key==field).value = this.searchData[field];
        }
        
        let param:NzTableQueryParams = { 
            pageSize:this.table.nzPageSize,
            pageIndex: this.table.nzPageIndex,
            sort: [],
            filter: this.currentFilter
        }
        this.table.nzQueryParams.emit(param);
        
        this.visible[field] = false;
        
    }

  reset(field: string): void {
    this.searchData[field] = '';
    if (this.activeColumnKey === field) {
      this.activeDateValue = null;
    }
    let index = this.currentFilter.findIndex(d=>d.key==field);
    if (index !== -1) {
      this.currentFilter.splice(index,1);
    }
    this.search(field);
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
        
        let { pageSize, pageIndex, sort, filter } = params;
        
        if ( this.currentFilter.length > 0 ){
            filter = this.currentFilter;
        }

        const currentSort = sort.find(item => item.value !== null);
        this.sortField = (currentSort && currentSort.key) || 'dataHoraInicial';
        this.sortOrder = (currentSort && currentSort.value) || 'descend';
        this.loadData();
        
        if ( sort.length > 0 ){
            this.sortFields(sort);
        }
    }

    sortFields(sort: {key:string,value:NzTableSortOrder}[]) {
       for (var item of sort ){
        if ( item.value != null ){
            
            this.messages.sort((a, b) => {
            if (typeof a[item.key] === 'string' && typeof b[item.key] === 'string') {
                
                    if ( a[item.key] > b[item.key] ) {
                        return 1 * (item.value == 'ascend' ? 1 : -1);
                    }
                    if ( a[item.key] < b[item.key] ) {
                        return -1 * (item.value == 'ascend' ? 1 : -1);
                    }
                    return 0;


            } else {
                return item.value === 'ascend'
                    ? Number(a[item.key]) - Number(b[item.key])
                    : Number(b[item.key]) - Number(a[item.key]);
            }
            
            });
          }
       }
    }

    openMessageLogDetail(agent:Agent, sessionId: string) {

        this.nzModal.create({
          nzTitle: this.ls.instant('agentBuilder.detailsConversation') + " - " + sessionId,
          nzContent: AgentBuilderMessagesLogDetailComponent,
          nzData:{
            agent: agent,
            sessionId: sessionId
          },
          nzMaskClosable: false,
          nzKeyboard: false,
          nzClosable: true,
          nzFooter:null,
          nzCentered: true,
          nzWidth: '80%',
          nzBodyStyle: { height: '90vh' , display:'flex', 'flex-direction':'column', overflow:'auto'},
        });

    }
}